import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';
import { breakpoints, colors, fontFamily, functions } from '../../ui/variables';

export const VersionStyle = styled.main`
  background-color: ${colors.white};
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone + 36}px 20px 48px;
  width: 100%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding: ${headerVariables.main.height.iphone + 64}px 64px 64px;
    display: flex;
    justify-content: center;
  }

  .versions-shell {
    width: 100%;
    max-width: 1100px;
  }

  .versions-header {
    ${fontFamily.sourceSansPro.bold}
    color: ${colors.veryDarkGray};
    font-size: 28px;
    margin: 0 0 18px 0;
    text-align: center;
  }

  .versions-list {
    display: grid;
    gap: 18px;
  }

  .version-card {
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 6px 18px rgba(6,20,36,0.06);
    border-left: 6px solid ${colors.lightGrayishBlue};
    background: ${colors.white};

    &.type-stable {
      border-left-color: ${colors.limeGreen};
      background: ${functions.rgba(colors.limeGreen, 0.06)};
    }

    &.type-feature {
      border-left-color: ${colors.softYellow};
      background: ${functions.rgba(colors.softYellow, 0.06)};
    }

    &.type-bugfix {
      border-left-color: ${colors.softBlue};
      background: ${functions.rgba(colors.softBlue, 0.04)};
    }

    &.type-hotfix {
      border-left-color: ${colors.softRed};
      background: ${functions.rgba(colors.softRed, 0.04)};
    }

    &.type-release {
      border-left-color: ${colors.softOrange};
      background: ${functions.rgba(colors.softOrange, 0.04)};
    }

    &.type-docs {
      border-left-color: ${colors.softPink};
      background: ${functions.rgba(colors.softPink, 0.04)};
    }

    &.type-chore {
      border-left-color: ${colors.softPurple};
      background: ${functions.rgba(colors.softPurple, 0.04)};
    }

    &.type-task {
      border-left-color: ${colors.black};
      background: ${functions.rgba(colors.black, 0.04)};
    }

    &.type-epic {
      border-left-color: ${colors.veryDarkGray};
      background: ${functions.rgba(colors.veryDarkGray, 0.04)};
    }

    &.type-refactor {
      border-left-color: ${colors.softBrown};
      background: ${functions.rgba(colors.softBrown, 0.04)};
    }

    .version-top {
      display: flex;
      gap: 12px;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .version-name {
        ${fontFamily.sourceSansPro.bold}
        color: ${colors.veryDarkGray};
        font-size: 16px;
      }

      .version-meta {
        display: flex;
        gap: 12px;
        align-items: center;
        color: ${colors.veryDarkGrayishBlue};
        font-size: 13px;
      }
    }

    .version-body {
      color: ${colors.veryDarkGrayishBlue};
      font-size: 14px;
      line-height: 20px;
      white-space: pre-line;
    }
  }
`;
